import { checkCDNUrl } from '@/utils/utils';

export class RegistrySerializer {

  private static INSTANCE = new RegistrySerializer();

  static get instance() {
    return this.INSTANCE;
  }

  public serializeToolRegistryList(payload: any, tenantID: any) {
    const toolList: any = [];
    const providersPayload = payload.providers ? payload.providers : [];
    for (const iterator of providersPayload) {
      iterator.logo = iterator.toolDetails && iterator.toolDetails.thumbnail ?
        checkCDNUrl(iterator.toolDetails.thumbnail) : '';
      iterator.subscriptions = iterator.toolDetails.subscriptions;
      iterator.subscriptionRequest = [];
      iterator.subscriptionsApproved = [];
      iterator.subscriptionsInreview = [];
      const subIndex = iterator.toolDetails.subscriptions.findIndex((subItem: any) => {
        return subItem.tenantId === tenantID;
      });
      iterator.isSubscribed = (subIndex !== -1) ? true : false;
      for (const iteratorSubscription of iterator.toolDetails.subscriptions) {
        if (iteratorSubscription.subscribeStatus === 'requested') {
          iterator.subscriptionRequest.push(iteratorSubscription);
        }
        if (iteratorSubscription.subscribeStatus === 'active') {
          iterator.subscriptionsApproved.push(iteratorSubscription);
        }
        if (iteratorSubscription.subscribeStatus === 'inreview') {
          iterator.subscriptionsInreview.push(iteratorSubscription);
        }
      }

      toolList.push(iterator);
    }
    const toolObject = {
      providers: toolList,
      totalCount: payload.totalCount,
    };
    return toolObject;
  }

  public serializeContentProviderList(payload: any, tenantID: any) {
    const providers = payload.contentRegistry ? payload.contentRegistry : [];
    for (const iterator of providers) {
      iterator.logo = iterator.thumbnail ? checkCDNUrl(iterator.thumbnail) : '';
      iterator.iconUrl = iterator.iconUrl ? checkCDNUrl(iterator.iconUrl) : '';

      if (iterator.toolDetails) {
        iterator.toolDescription = iterator.toolDetails.description ? iterator.toolDetails.description : undefined;
        iterator.subscriptions = iterator.toolDetails.subscriptions;
        iterator.subscriptionRequest = [];
        iterator.subscriptionsApproved = [];
        iterator.subscriptionsInreview = [];
        const subIndex = iterator.toolDetails.subscriptions.findIndex((subItem: any) => {
          return subItem.tenantId === tenantID;
        });
        iterator.isSubscribed = (subIndex !== -1) ? true : false;

        for (const iteratorSubscription of iterator.toolDetails.subscriptions) {
          if (iteratorSubscription.subscribeStatus === 'requested') {
            iterator.subscriptionRequest.push(iteratorSubscription);
          }
          if (iteratorSubscription.subscribeStatus === 'active') {
            iterator.subscriptionsApproved.push(iteratorSubscription);
          }
          if (iteratorSubscription.subscribeStatus === 'inreview') {
            iterator.subscriptionsInreview.push(iteratorSubscription);
          }
        }

      }
    }
    const payloadObject = {
      contentRegistry: providers,
      totalCount: payload.totalCount,
    };
    return payloadObject;
  }
}

export const registrySerializer = RegistrySerializer.instance;

